<template>
  <div class="activationCodeUsage pointer">
    <!-- <NavBar :title="useType == 0 ? '激活码新增' : '激活码续时'" /> -->
    <div class="navBar">
      <div class="fanhuiBox" @click="fanhui()">
        <img class="fanhui" src="@/assets/icons/fanhui.png" alt="" />
      </div>
      <div class="title">
        <p>{{ useType == 0 ? "激活码新增" : "激活码续时" }}</p>
      </div>
      <!-- <div class="navBtn" @click="cutUseType">
        <img src="@/assets/icons/cutLogoType.png" alt="" />
        <div>{{ useType == 0 ? "续时" : "新增" }}</div>
      </div> -->
    </div>
    <div class="content">
      <div class="mains">
        <div class="main_top">
          <span
            >使用激活码进行{{ useType == 0 ? "新增" : "续时" }}云手机：</span
          >
        </div>
        <div class="main_jhm">
          <van-field
            v-model="value"
            placeholder="请输入激活码"
            type="textarea"
            @input="onInput"
          />
        </div>
      </div>
      <div class="maint">
        <div class="main_top">
          <span>使用说明</span>
        </div>
        <div class="shiyong">
          <p>1、每个激活码只能激活一次。</p>
          <p>2、您通过非官方渠道获取的激活码，若无法激活，迅流手机概不负责。</p>
          <p>3、输入激活码新增或续时云手机时，多个激活码需要换行输入。</p>
          <p>4、单次激活最多添加200个激活码。</p>
          <p>
            5、使用激活码续时云手机时，输入激活码然后点击确认激活即可选择对应的云手机进行续时，若激活码数量多于续时云手机时，部分云手机会使用多张激活码；若续时的云手机数量多于输入激活码数量时，多出的云手机将无法
            续费。
          </p>
          <p>6、激活码使用失败时，可通过页面提示联系客服处理。</p>
          <p>7、迅流云手机对激活码使用拥有最终解释权。</p>
        </div>
      </div>
    </div>
    <div class="baseBox">
      <button class="qdsq_btn" @click="activationuse">确认激活</button>
    </div>
    <detainmentDialog
      v-model="showDialog"
      width="298"
      confimText="确认激活"
      cancelText="取消"
      cancelType="primary"
      @confim="confirmModel"
      @change="changeModel"
      title="请选择需要激活的系统版本"
    >
      <div class="contentBox">
        <div
          v-for="(item, index) in verifySkuList"
          :key="index"
          :class="['verifySkuItem', skuActive == index ? 'skuActive' : '']"
          @click="skuActive = index"
        >
          {{ item.deviceVersionName }}
        </div>
      </div>
    </detainmentDialog>
  </div>
</template>
  
  <script>
import NavBar from "@/components/NavBar.vue";
import { Toast } from "vant";
import {
  activationuseadd,
  activationVerifySku,
  addActivationVerifySku,
} from "@/api/buy/index";
import { mapState, mapMutations } from "vuex";
import detainmentDialog from "@/components/publicDialog/detainmentDialog.vue";
export default {
  name: "ActivationCodeUsage",
  components: {
    NavBar,
    detainmentDialog,
  },
  data() {
    return {
      value: "",
      useType: 0,
      showDialog: false,
      verifySkuList: [],
      skuActive: 0,
    };
  },

  mounted() {
    this.useType = this.$route.query.type;
  },

  methods: {
    ...mapMutations("persistence", [
      "SET_ACTIVATIONCODELIST",
      "SET_ISACTIVATIONCODE",
    ]),
    fanhui() {
      this.$router.go(-1);
    },
    cutUseType() {
      if (this.useType == 0) {
        this.useType = 1;
      } else {
        this.useType = 0;
      }
    },
    // 跳转页面
    chakanshouji() {
      this.$router.push({
        path: "/Selectedphonebeen",
      });
    },
    onInput(value) {
      // 只允许数字和字母
      this.value = value.replace(/[^a-zA-Z0-9\n]/g, "");
    },
    activationCodeEverify() {
      let malist = this.value.trim().split(/\s+/);
      if (!this.value) {
        Toast("请输入激活码");
        return false;
      }
      if (malist.length > 200) {
        Toast("激活码数量不能超过200！");
        return false;
      }
      const oneVerifyMalistWrong = malist.filter(function (item) {
        return item.length < 10 || item.length > 13;
      });

      if (findDuplicates(malist).length > 0) {
        Toast(findDuplicates(malist) + " 激活码重复，请检查后重新输入！");
        return false;
      }
      if (oneVerifyMalistWrong.length > 0) {
        Toast("激活码" + oneVerifyMalistWrong + "格式错误,请检查后重新输入");
        return false;
      }
      return malist;
      // 找出数组中的重复元素
      function findDuplicates(arr) {
        const seen = new Set();
        const duplicates = new Set();
        for (const item of arr) {
          if (seen.has(item)) {
            duplicates.add(item);
          } else {
            seen.add(item);
          }
        }
        return Array.from(duplicates);
      }
    },
    // 使用激活码
    async activationuse() {
      if (this.activationCodeEverify()) {
        if (this.useType == 0) {
          // 激活码新增
          let data = {
            activationCodes: this.activationCodeEverify(),
          };
          addActivationVerifySku(this.activationCodeEverify()).then((res) => {
            if (res.code == 200) {
              if (res.data.length > 1) {
                this.showDialog = true;
                this.verifySkuList = res.data;
              } else {
                activationuseadd(data).then((res) => {
                  if (res.code == 200) {
                    this.SET_ACTIVATIONCODELIST(res.data);
                    this.$router.push({
                      path: "/activationResult",
                    });
                  }
                });
              }
            }
          });
          return;
        } else {
          // 激活码续时
          activationVerifySku(this.activationCodeEverify()).then((res) => {
            if (res.code == 200) {
              let ids = res.data.map((item) => item.id).join(",");
              this.SET_ISACTIVATIONCODE(this.activationCodeEverify());
              this.$router.push({
                path: "/choosecloudphone",
                query: { skuIds: ids },
              });
            }
          });
        }
      }
    },
    confirmModel() {
      let data = {
        activationCodes: this.activationCodeEverify(),
        skuId: this.verifySkuList[this.skuActive].id,
      };
      activationuseadd(data).then((res) => {
        if (res.code == 200) {
          this.SET_ACTIVATIONCODELIST(res.data);
          this.$router.push({
            path: "/activationResult",
          });
        }
      });
    },
    changeModel() {},
  },
};
</script>
  
  <style lang="less" scoped>
.activationCodeUsage {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: MiSans, MiSans;
  .navBar {
    position: relative;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .fanhuiBox {
      height: 100%;
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .fanhui {
        width: 17px;
        height: 17px;
      }
    }
    .title {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-weight: 600;
      font-size: 17px;
    }
    .navBtn {
      margin-right: 12px;
      color: #886df3;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        margin-right: 2px;
      }
    }
  }
}
.content {
  padding: 10px 13px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
}
.mains {
  width: 100%;
  padding: 17px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  text-align: left;
  .main_top {
    padding-bottom: 17px;
    border-bottom: 1px solid #f5f7fb;
    font-weight: 500;
    font-size: 15px;
    color: #505465;
  }
  .main_jhm {
    width: 100%;
    height: 152px;
    background: #f7f7f7;
    border-radius: 6px;
    overflow: hidden;
    margin: 17px 0;
    .van-field {
      height: 152px;
      background: #f7f7f7;
      /deep/.van-field__control {
        height: 132px;
        background: #f7f7f7;
      }
    }
  }
  .tianjia {
    text-align: right;
    .querentianjia {
      width: 99px;
      height: 36px;
      border-radius: 18px 18px 18px 18px;
      border: 1px solid #6da8ff;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #0066ff;
      line-height: 22px;
      background: #ffffff;
    }
  }
}
.maint {
  width: 100%;
  margin: 10px 0;
  padding: 15px 12px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  .main_top {
    padding-bottom: 17px;
    border-bottom: 1px solid #f5f7fb;
    font-weight: 500;
    font-size: 15px;
    color: #505465;
    text-align: left;
  }
  .shiyong {
    margin-top: 13px;
  }
  .shiyong p {
    margin: 4px 0;
    text-align: left;
    font-size: 13px;
    color: #a9adb6;
    line-height: 22px;
  }
}
.baseBox {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 8px 0 hsla(0, 0%, 39%, 0.2);
  color: #333;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 0;
  .qdsq_btn {
    width: 90%;
    height: 44px;
    border: none;
    background: #886df3;
    border-radius: 44px;
    font-size: 16px;
    color: #f6f8fb;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
  }
}
.contentBox {
  .verifySkuItem {
    height: 42px;
    line-height: 42px;
    font-weight: 600;
    font-size: 14px;
    color: #505465;
  }
  .skuActive {
    background: #f0edfe;
    color: #886df3;
  }
}
</style>